export function Button({ variant = "primary", className = "", ...props }) {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-lg font-semibold px-4 py-2.5 transition disabled:opacity-50 disabled:cursor-not-allowed";
  const variants = {
    primary: "bg-brand-600 text-white hover:bg-brand-700",
    secondary: "bg-white text-slate-700 border border-slate-300 hover:bg-slate-50",
    danger: "bg-red-600 text-white hover:bg-red-700",
    ghost: "text-slate-600 hover:bg-slate-100",
  };
  return <button className={`${base} ${variants[variant] || variants.primary} ${className}`} {...props} />;
}

export function Field({ label, hint, error, children }) {
  return (
    <label className="block">
      {label && <span className="block text-sm font-medium text-slate-700 mb-1">{label}</span>}
      {children}
      {error ? (
        <span className="block text-xs text-red-600 mt-1">{error}</span>
      ) : hint ? (
        <span className="block text-xs text-slate-400 mt-1">{hint}</span>
      ) : null}
    </label>
  );
}

const inputBase =
  "w-full rounded-lg border border-slate-300 px-3 py-2.5 text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500";

export function Input(props) {
  return <input className={`${inputBase} ${props.className || ""}`} {...props} />;
}
export function Textarea(props) {
  return <textarea className={`${inputBase} ${props.className || ""}`} {...props} />;
}
export function Select(props) {
  return <select className={`${inputBase} bg-white ${props.className || ""}`} {...props} />;
}

export function Alert({ kind = "error", children }) {
  if (!children) return null;
  const kinds = {
    error: "bg-red-50 text-red-700 border-red-200",
    success: "bg-green-50 text-green-700 border-green-200",
    info: "bg-brand-50 text-brand-700 border-brand-100",
  };
  return (
    <div className={`rounded-lg border px-3 py-2 text-sm ${kinds[kind] || kinds.error}`}>{children}</div>
  );
}

export function Spinner({ className = "" }) {
  return (
    <span
      className={`inline-block h-5 w-5 animate-spin rounded-full border-2 border-white/40 border-t-white ${className}`}
    />
  );
}

export function EmptyState({ title, children }) {
  return (
    <div className="text-center py-16 px-4">
      <h3 className="text-lg font-semibold text-slate-700">{title}</h3>
      {children && <p className="text-slate-500 mt-1 max-w-sm mx-auto">{children}</p>}
    </div>
  );
}
